import { FC } from 'react';
import { ProSwitch } from '../antd';
import SimpleFormDisabled from './subpage/disabled';
import SimpleFormItem from './subpage/simpleFormItem';
import { BaseSimpleFormProps, SimpleFormItemEnum } from './interface';
import { SwitchProps } from 'antd/lib/switch';

export interface SimpleFormSwitchProps extends BaseSimpleFormProps {
  switchProps?: SwitchProps;
}
const simpleFormSwitch: FC<SimpleFormSwitchProps> = props => {
  const { disabledRender, switchProps, form, ...restProps } = props;
  const handleRender = (val: boolean) => {
    if (disabledRender) return disabledRender;
    return val
      ? switchProps?.checkedChildren || '是'
      : switchProps?.unCheckedChildren || '否';
  };
  return (
    <SimpleFormItem valuePropName="checked" {...restProps}>
      {switchProps?.disabled ? (
        <SimpleFormDisabled
          name={props.name}
          form={form}
          render={handleRender}
        />
      ) : (
        <ProSwitch {...switchProps} />
      )}
    </SimpleFormItem>
  );
};

simpleFormSwitch.displayName = SimpleFormItemEnum.SimpleFormSwitch;

export default simpleFormSwitch;
